export const stationObject = {
    id: -1,
    name: '',
    sourcesTypes: []
}

export const datasourceTypeObject = {
    id: -1,
    name: '',
    codes: []
}

export const datasourceObject = {
    id: -1,
    serialNum: '',
    codes: []
}

export const codeObject = {
    id: -1,
    code: '',
    entities: []
}

export const stnEntity = {
    id: -1,
    name: '',
    valueParamsString: ''
}

const filterObject = {
    rowId: 0,
    type: {...datasourceTypeObject},
    code: {...codeObject},
    stnEntity: {...stnEntity},
    operation: ''
}

const rainFloodFilterObject = {
    rowId: 0,
    type: {...datasourceTypeObject},
    datasource: {...datasourceObject}
}

export const defaultConstructor = {
    id: null,
    curRowNum: 1,
    type: "",
    name: "",
    station: {...stationObject},
    filtersRows: [{...filterObject}],
    withoutDays: false,
    multiplyDimension: false,
    duplicationType: 'NONE',
    decadeOperations: [],
    tableOperations: [],
    editable: true,
    isDialogShown: false
}

export const rainFloodConstructor = {
    id: null,
    curRowNum: 1,
    type: "",
    name: "",
    station: {...stationObject},
    catchmentArea: null,
    polynomialCoefficient: null,
    runoffLayerFiltersRows: [{...rainFloodFilterObject}], //сток
    sedimentLayerFiltersRows: [{...rainFloodFilterObject}], //осадки
    editable: true
}

export const riverFloodConstructor = {
    id: null,
    curRowNum: 1,
    type: "",
    name: "",
    station: {...stationObject},
    catchmentArea: null,
    polynomialCoefficient: null,
    runoffLayerFiltersRows: [{...rainFloodFilterObject}], //сток
    sedimentLayerFiltersRows: [{...rainFloodFilterObject}], //осадки
    snowLayerFiltersRows: [{...rainFloodFilterObject}], //снежный покров
    editable: true
}

export const evaporationConstructor = {
  id: null,
  type: "",
  name: "",
  station: {...stationObject},
  stationEntity: {...stnEntity},
  waterTemperatureFilterObject: {
    meteoCode: {...codeObject},
    type: {...datasourceTypeObject},
    datasource: {...datasourceObject}
  },
  windSpeedFilterObject: {
    meteoCode: {...codeObject},
    type: {...datasourceTypeObject},
    datasource: {...datasourceObject}
  },
  editable: true
}
